var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponse2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3270_38140",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 3.75H2.5V16.3676H5.49904L5.49905 18.75L8.67551 16.3676H17.5V3.75Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.75V2.5H1.25V3.75H2.5ZM17.5 3.75H18.75V2.5H17.5V3.75ZM2.5 16.3676H1.25V17.6176H2.5V16.3676ZM5.49904 16.3676L6.74904 16.3676L6.74903 15.1176H5.49904V16.3676ZM5.49905 18.75L4.24905 18.75L4.24907 21.25L6.24905 19.75L5.49905 18.75ZM8.67551 16.3676V15.1176H8.25884L7.92551 15.3676L8.67551 16.3676ZM17.5 16.3676V17.6176H18.75V16.3676H17.5ZM2.5 5H17.5V2.5H2.5V5ZM3.75 16.3676V3.75H1.25V16.3676H3.75ZM5.49904 15.1176H2.5V17.6176H5.49904V15.1176ZM6.74905 18.75L6.74904 16.3676L4.24904 16.3677L4.24905 18.75L6.74905 18.75ZM7.92551 15.3676L4.74905 17.75L6.24905 19.75L9.42551 17.3676L7.92551 15.3676ZM17.5 15.1176H8.67551V17.6176H17.5V15.1176ZM16.25 3.75V16.3676H18.75V3.75H16.25Z",
    fill: "#7F82A2",
    mask: "url(#path-1-inside-1_3270_38140)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponse2);
export default __webpack_public_path__ + "static/media/response2.c7db505f87b4e4fdac022ab451bfdc3f.svg";
export { ForwardRef as ReactComponent };